export default __webpack_public_path__ + "static/media/Rectangle 53(3).59fd15bd.png";